/** The one place a Subscriber Desk route is built. Every link is absolute. */
export type DeskPage = 'activity' | 'search' | 'help'

const q = (params?: Record<string, string>): string => {
  const s = new URLSearchParams(params ?? {}).toString()
  return s ? `?${s}` : ''
}

/** The Desk's own pages: Activity (home), Find a member, the manual. */
export function deskHref(page: DeskPage = 'activity', hash?: string): string {
  const base = page === 'search' ? '/desk/find' : page === 'help' ? '/desk/help' : '/desk'
  return `${base}${hash ? `#${hash}` : ''}`
}
export const memberHref = (id: number): string => `/desk/members/${id}`
/** The take-a-payment screen; opts become query parameters. */
export const paymentHref = (id: number | 'new', opts?: Record<string, string>): string => `${id === 'new' ? '/desk/members/new' : memberHref(id)}/pay${q(opts)}`
export const printHref = (id: number, what: string): string => `${memberHref(id)}/print/${encodeURIComponent(what)}`
export const batchHref = (id?: number): string => (id === undefined ? '/desk/batch' : `/desk/batch/${id}`)
